import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Mailto from 'react-mailto';
import Slider from 'react-slick';
import scrollToComponent from 'react-scroll-to-component';

import AntiModal from '../../common/modal/AntiModal';
import {TeamModalContainer} from './TeamModal';

import {displayPhone} from '../../../utils/formatting';

import * as stores from '../../../constants/stores';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Store extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    
    let isMobile = window.innerWidth <= 768;

    this.state = {
      store: stores.ALL[this.props.route.store_id],
      // activePromo: this.props.route.store_id === 'coh' || this.props.route.store_id === 'vab',
      holidayHours: false,
      hoursNotice: false,
      biosOpen: false,
      openModal: false,
      selectedMember: null,
      biosClass: stores.ALL[this.props.route.store_id].team && stores.ALL[this.props.route.store_id].team.length < 8 && !isMobile ? 'biosSection limitedBios' : 'biosSection',

      openHoursModal: false, 
    };

    // Bind event listeners
    this.setBiosClass = ::this.setBiosClass;
  }

  componentWillMount() {
    document.title = this.state.store.title;
    document.getElementsByTagName("META")[7].content = this.state.store.description;

    window.addEventListener('resize', this.setBiosClass, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setBiosClass, false);
  }

  componentDidMount() {
    if(window.location.href.includes('scroll=event')) {
      setTimeout(() => {
        this.scrollToPromo();
      }, 250);
    }
  }

  scrollToTeam() {
    scrollToComponent(this.biosSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollToPromo() {
    if(!this.promoSection) { return; }
    scrollToComponent(this.promoSection, {
      offset: 200, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  facebookNav() {
    let win = window.open(this.state.store.facebookUrl, '_blank');
    win.focus();
  }

  instagramNav() {
    let win = window.open(this.state.store.instagramUrl, '_blank');
    win.focus();
  }

  pinterestNav() {
    let win = window.open('https://www.pinterest.com/diamondsdirect/', '_blank');
    win.focus();
  }

  instagramDefault() {
    let win = window.open('https://www.instagram.com/diamondsdirect/', '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  giftsNav(page) {
    window.location.href = 'https://gifts.diamondsdirect.com';
  }

  fetchHours() {
    return this.state.holidayHours ? this.state.store.hours.holiday : this.state.store.hours.default;
  }

  setBiosClass() {
    let isMobile = window.innerWidth <= 768;
    this.setState({
      biosClass: this.state.store.team && this.state.store.team.length < 8 && !isMobile ? 'biosSection limitedBios' : 'biosSection',
    });
  }

  toggleBios() {
    this.setState({
      biosOpen : !this.state.biosOpen,
    });
  }

  openTeamModal(member) {
    this.setState({
      openModal: true,
      selectedMember: member
    });
  }

  openHoursModal() {
    this.setState({
      openHoursModal: true,
    });
  }

  closeTeamModal() {
    this.setState({
      openModal: false,
    }, () => {
      setTimeout(() => {
        this.setState({
          selectedMember: null,
        });
      }, 400);
    });
  }

  closeHoursModal() {
    this.setState({
      openHoursModal: false,
    });
  }

  nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

  renderRotatingBanner() {
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 10000,
      cssEase: "linear",
      arrows: false,
    };
    return <div className='storeRotatingBanner'>
      <div className="bannerLeft" onClick={::this.prevSlide}>
        <div className="leftArrow"></div>
      </div>
      <div className="bannerRight" onClick={::this.nextSlide}>
        <div className="rightArrow"></div>
      </div>
      <Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>
        <div className={'rotatingBannerItem fall2018promoBanner'}>
          <img className='desktopOnly' src={'https://ddw2.diamondsdirect.com/img/store/promo-banners/' + this.props.route.store_id + '/vd20_banner.jpg'} />
          <img className='midMobile' src={'https://ddw2.diamondsdirect.com/img/store/promo-banners/' + this.props.route.store_id + '/vd20_banner_midmobile.jpg'} />
          <img className='mobile600' src={'https://ddw2.diamondsdirect.com/img/store/promo-banners/' + this.props.route.store_id + '/vd20_banner_mobile.jpg'} />
        </div>
        <div className="rotatingBannerItem">
          <img className='desktopOnly' src={'https://ddw2.diamondsdirect.com/img/promopages/fall2019/store_banner.jpg'} />
          <img className='midMobile' src={'https://ddw2.diamondsdirect.com/img/promopages/fall2019/store_banner_midmobile.jpg'} />
          <img className='mobile600' src={'https://ddw2.diamondsdirect.com/img/promopages/fall2019/store_banner_mobile.jpg'} />
        </div>
      </Slider>
    </div>;
  }

  // For Valentine's 2019 Promo
  getDesignerFullName(code) {
    switch (code) {
      case 'ajaffe':
        return 'A. Jaffe Designer';
      case 'christopher':
        return 'Christopher Designs Designer';
      case 'amden':
        return 'Amden Designer';
      case 'simong':
        return 'Simon G. Designer';
      default:
        return 'Designer';
    }
  }

  covidPreRedText() {
    
    return null;

    // let useDefault = [
  //      'atx',
  //      'bhm',
  //      'dfw',
  //      'ftx',
  //      'san',
  //    ];
  //    if(useDefault.includes(this.props.route.store_id)) {
  //      return <div style={{fontStyle: 'italic', fontWeight: '300'}}>As of Friday, April 24<sup>th</sup></div>;
  //    } else {
  //      return null;
  //    }
  }

    covidBottomText() {
      switch (this.props.route.store_id) {
        case 'chs':
          return this.reopenedBottomText();
        case 'bhm':
          return this.reopenedBottomText();
        case 'atx':
          return this.reopenedBottomText();
        case 'dfw':
          return this.reopenedBottomText();
        case 'ftx':
          return this.reopenedBottomText();
        case 'san':
          return this.reopenedBottomText();
        case 'nol':
          return this.reopenedBottomText();
        case 'okc':
          return this.reopenedBottomText();
        case 'jax':
          return this.reopenedBottomText();
        case 'coh':
          return this.reopenedBottomText();
        case 'cle':
          return this.reopenedBottomText();
        case 'vab':
          return this.reopenedBottomText();
        case 'rva':
          return this.reopenedBottomText();
        default:
          return this.reopenedBottomText();
      }
    }

    covidHours() {
      let useDefault = [
        'atx',
        'bhm',
        'boc',
        'chs',
        'dfw',
        'ftx',
        'san',
        'nol',
        'okc',
        'jax',
        'coh',
        'cle',
        'vab',
        'rva',
        'clt',
        'ral',
        'kcy',
        'stl',
        'ind',
        'pit',
        'hou',
        'gsc',
        'nva',
        'bay',
        'try',
      ];
      return useDefault.includes(this.props.route.store_id);
    }

    reopenedBottomText() {

      if(this.props.route.store_id === 'boc' && false) {
        return <div>
          <div style={{marginTop: '10px', color: '#4B2D53', display: 'none'}}>Special Sunday Hours: We will be open on 6/27 from 12 p.m. to 5 p.m.</div>
          <div style={{marginTop: '10px'}}>No appointment is necessary for in-store shopping. You can also shop with us from the comfort of your home with our new <span style={{fontWeight: '700', cursor: 'pointer'}} onClick={() => this.userNav('virtual')}>remote and virtual shopping tools</span>. <span style={{fontWeight: '700', cursor: 'pointer'}} onClick={() => this.userNav('covid-19-updates')}>Click here</span> for information on safe shopping protocols.</div>
          <div style={{marginTop: '10px'}}>For special hours <a href={this.state.store.facebookUrl} target="_blank">visit Facebook</a>.</div>
        </div>
      } else {
        return <div>
          <div style={{marginTop: '10px', color: '#4B2D53', display: 'none'}}>Closed Monday, Sept 6th for Labor Day</div>
          {this.state.store.facebookUrl ?
            <div style={{marginTop: '10px'}}>For special hours <a href={this.state.store.facebookUrl} target="_blank">visit Facebook</a>.</div> :
            null
          }
        </div>
      }
    }

    defaultCovidBottomText() {
      return <div>Although our showrooms are temporarily closed due to COVID-19, we are still available to help you! Our diamond experts are on-call and have the tools to educate and guide you from the comfort of your home.</div>
    }


  departmentChat(deptId) {
    
  }

  agentChat(agentId) {
    if(agentId) {
      acquireIO.max('text', agentId);
    } else {
      acquireIO.max('text');
    }
  }

  agentVideo(agentId) {
    if(agentId) {
      acquireIO.max('video', agentId);
    } else {
      acquireIO.max('video');
    }
  }

  // Back to Dec
  // <img className='desktopOnly' src={`https://ddw2.diamondsdirect.com/img/promopages/december2022/store/storepage.jpg`} />
  // <img className='midMobile' src={`https://ddw2.diamondsdirect.com/img/promopages/december2022/store/storepage_m_landscape.jpg`} />
  // <img className='mobile600' src={`https://ddw2.diamondsdirect.com/img/promopages/december2022/store/storepage_m.jpg`} />

  render() {

    const hasMultipleBanners = ['kcy', 'cle', 'ftx', 'boc', 'hou', 'pit', 'gsc', 'nva', 'bay', 'try'].includes(this.props.route.store_id);

    const isWeek1 = ['atx', 'chs', 'okc', 'vab', 'san', 'ind', 'coh', 'kcy', 'nol', 'nva', 'try'].includes(this.props.route.store_id);
    const isWeek2 = ['clt', 'bhm', 'ral', 'rva', 'dfw', 'ftx', 'stl', 'cle', 'boc', 'hou', 'bay', 'pit', 'jax', 'gsc'].includes(this.props.route.store_id);

    const isWeek1Custom = ['coh', 'ind', 'san', 'vab'].includes(this.props.route.store_id);
    const isWeek2Custom = ['bhm', 'cle', 'clt', 'ftx', 'hou', 'pit', 'ral', 'rva', 'stl', 'jax'].includes(this.props.route.store_id);

    return <div className='Store'>
      <div className='bannerSection'>
        {this.state.store.currentPromo || true ?
          <div>
            <div>
              <div>
                <img className='desktopOnly' src={`https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/store-page-banner.jpg`} />
                <img className='midMobile' src={`https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/storepage_banner_mobilelandscape.jpg`} />
                <img className='mobile600' src={`https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/store-page-mobile.jpg`} />
                <div 
                  className={'bannerSectionButton'} 
                  onClick={() => this.internalNav('mothers-day')} 
                  style={{display: 'none'}}><div>Shop Gifts for Mom</div></div>
              </div>
              <button className='bannerSectionButton' onClick={() => this.internalNav('holiday')} style={{display: 'none'}}>Learn More</button>
            </div>
          </div> :
          <div>
            <div>
              {hasMultipleBanners ?
                <div>
                  <img className='desktopOnly' src={'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/storepage_banner-c.jpg'} />
                  <img className='midMobile' src={'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/storepage_banner_mobilelandscape-c.jpg'} />
                  <img className='mobile600' src={'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/storepage_mobile-c.jpg'} />
                </div> :
                <img src={'https://ddw2.diamondsdirect.com/img/store/homepage-banners/' + this.props.route.store_id + '/default.jpg'} />
              }
            </div>
          </div>
        }
      </div>
      <div className='infoSection'>
        <div className='infoTitle'>{this.state.store.name}</div>
        <div className='infoDescriptionWrapper'>
          {this.state.store.mainDescription.map((desc, i) => {
            return <div className='infoDescriptionP' key={i}>{desc}</div>
          })}
        </div>
        <div className='infoRowWrapper'>
          <div className='infoRow'>
            <div className='locationWrapper'>
              <div className='locationTitle'>Location</div>
              <a className='locationLink' href={this.state.store.googleMapsLink} target='_blank'>
                <div className='locationBody'>
                  <div className='locationBodyRow'>{this.state.store.address.line1}</div>
                  <div className='locationBodyRow'>{this.state.store.address.line2}</div>
                </div>
              </a>

              <div className='locationTitle contactTitle'>Contact Us</div>
              <div className='phoneWrapper'>
                <div className='phoneIcon'></div>
                <a href={'tel:' + this.state.store.phone}>
                  <div className='phoneValue'>{displayPhone(this.state.store.phone)}</div>
                </a>
              </div>
              <div className='emailWrapper'>
                <div className='emailIcon'></div>
                <div className='emailValue'>
                  <a href={'mailto:' + this.state.store.email}>{this.state.store.email}</a>
                </div>
              </div>

            </div>
            <div className='hoursWrapper'>
              <div className='hoursTitle'>Hours</div>
              <div className='hoursBody'>
                {this.covidPreRedText()}
                <div>
                  <div style={{ display: 'none' }}>
                    {this.fetchHours().map((hour, i) => {
                      if(this.covidHours()) {
                        return <div className='hoursBodyRow' key={i}>{hour.days}: {hour.hours}</div>;
                      } else {
                        if(i === 0) {
                          return <div className='hoursBodyRow' key={i}>Opening soon!</div>;
                        } else {
                          return null;
                        }
                      }                     
                    })}
                  </div>
                  {true ?
                    <div className='hoursBodyRow hoursNoticeNormal hoursLink' onClick={::this.openHoursModal}>See Special Holiday Hours</div> :
                    null
                  }
                  <div className='hoursBodyRow hoursNotice' style={{ color: '#4B2D53', display: isWeek1 ? 'none' : 'none'}}>Special Holiday Hours:<br />Nov 11: 10am-8pm<br />Nov 12: 10am-7pm<br />Nov 13: 12pm-6pm</div>
                  <div className='covidBottomWrapper'>{this.covidBottomText()}</div>
                </div>
                <div style={{display: 'none'}}>
                  {this.state.store.hours.notice ?
                    <div className='hoursBodyRow hoursNotice' dangerouslySetInnerHTML={{__html: this.state.store.hours.notice}} /> :
                    <div>
                      {this.state.store.facebookUrl ?
                        <div>
                          <div className='hoursBodyRow hoursNoticeNormal'>Please visit <a href={this.state.store.facebookUrl} target="_blank">Facebook</a> for weather-related closings and other delays</div>
                        </div> :
                        null
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div className='infoRow'>

          </div>
        </div>

        {this.props.route.store_id === 'clt' ?
          <div>
            <div className='infoCTA' onClick={() => this.openNew('https://diamondsdirecttimepieces.com/')} style={{ width: '280px' }}>Diamonds Direct Timepieces</div>
          </div> :
          null
        }

        <div className='infoCTA' onClick={::this.scrollToTeam}>Meet the Team</div>
        <div className='infoCTA' onClick={() => this.internalNav('contact-us')}>Book Appointment</div>

        <div className='infoSocial'>
          <div className='infoSocialHeader'>Let’s Get Social</div>
          {this.state.store.facebookUrl ?
            <div className='infoSocialIcon' onClick={::this.facebookNav}>
              <i className="fab fa-facebook-f"></i>
            </div> :
            null
          }
          {this.state.store.instagramUrl ?
            <div className='infoSocialIcon' onClick={::this.instagramNav}>
              <i className="fab fa-instagram"></i>
            </div> :
            <div className='infoSocialIcon' onClick={::this.instagramDefault}>
              <i className="fab fa-instagram"></i>
            </div>
          }
          <div className='infoSocialIcon' onClick={::this.pinterestNav}>
              <i className="fab fa-pinterest"></i>
            </div>
          
        </div>
        {this.state.store.sponsorships && this.state.store.sponsorships.length > 0 ?
          <div className='sponsorshipSection'>
            <div className='sponsorshipSubtitle'>Home Team Pride</div>
            <div className='sponsorshipLogos'>
              {this.state.store.sponsorships.map((sponsorship, i) => {
                var sponsorSrc = 'https://ddw2.diamondsdirect.com/img/store/sponsorships/' + this.props.route.store_id + '/' + sponsorship.image;
                return <div className={this.state.store.sponsorships.length === 1 ? 'sponsorLogo single' : 'sponsorLogo'} key={i}><img src={sponsorSrc} alt={sponsorship.name} /></div>;
              })}
            </div>
          </div> :
          null
        }
      </div>
      <div className='reviewSection'>
        <div>
          <div className='footerLine'>We’d love to hear from you! </div>
        </div>
        <div>
          <div className='footerLine'>Leave&nbsp;us&nbsp;a&nbsp;</div>
          <div className='footerButton' onClick={() => {this.openNew(this.state.store.reviews.googleWrite)}}>Review</div>
          <div className='footerLine'>&nbsp;or&nbsp;</div>
          <div className='footerButton' onClick={() => {this.openNew(this.state.store.reviews.googleRead)}}>Read</div>
          <div className='footerLine'>&nbsp;what&nbsp;others&nbsp;have&nbsp;to say.</div>
        </div>
      </div>
      {this.state.store.currentPromo || true ?
        <div>
          <div className='promoSection' ref={(div) => { this.promoSection = div; }}>
            <div className='promoBanner'>
              <img className='desktop600' src={`https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/Event-Banner.jpg`} />
              <img className='mobile600' src={`https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/event-mobile.jpg`} />
            </div>
            <div className='promoContentDefault' style={{position: 'relative'}}>
              <img src={`https://ddw2.diamondsdirect.com/img/promopages/earring2022/store/event.jpg`} />
            </div>
          </div>
        </div> :
        null
      }
      {this.state.store.video ? 
        <div className='videoSection'>
          <div className='videoWrapper'>
            <iframe src={this.state.store.video} frameborder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
          </div>
        </div> :
        null
      }
      {this.props.route.store_id === 'nol' ?
        <div className='audioSection' style={{display: 'none'}}>
          <div className='audioLabel'>Listen to an interview with our general manager:</div>
          <div className='audioWrapper'>
            <audio
              controls
              src="https://ddw2.diamondsdirect.com/img/store/audio/nol.mp3">
            </audio>
          </div>
        </div> :
        null
      }
      {this.props.route.store_id === 'ftx' && false ?
        <div className='videoSection'>
          <div className='videoWrapper'>
            <iframe src="https://player.vimeo.com/video/365145124" frameborder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
          </div>
        </div> :
        null
      }


      <div className={this.state.biosClass} ref={(div) => { this.biosSection = div; }} style={{display: this.state.store.team.length === 0 ? 'none' : 'block'}}> 
        <div className='biosTitle'>Meet Your {this.state.store.shortName} Team</div>
        <div className={this.state.biosOpen ? 'biosWrapper open' : 'biosWrapper'}>
          {this.state.store.team.map((member, i) => {
            let bioSrc = 'https://ddw2.diamondsdirect.com/img/store/team/' + this.props.route.store_id + '/' + member.picture;
            return <div className='memberBio' key={i} onClick={() => {this.openTeamModal(member)}}>
                      <img src={bioSrc} />
                      <div className='memberOverlay'>
                        <div className='memberInfo'>
                          <div className='memberName'>{member.name}</div>
                          <div className='memberTitle'>{member.title}</div>
                        </div>
                      </div>
                    </div>;
          })}
        </div>
        <div className='biosViewControls'>
          <div className={this.state.biosOpen ? 'biosViewMore hidden' : 'biosViewMore'} onClick={::this.toggleBios}>
            <div className='moreText'>View More</div>
            <div className='downArrow'></div>
          </div>
          <div className={this.state.biosOpen ? 'biosViewLess' : 'biosViewLess hidden'} onClick={::this.toggleBios}>
            <div className='upArrow'></div>
            <div className='lessText'>View Less</div>
          </div>
        </div>
      </div>
      {this.state.store.awards && this.state.store.awards.length > 0 ?
        <div className='awardsSection'>
          <div className='awardsSubtitle'>Awards and Recognition</div>
          <div className='awardsLogos'>
            {this.state.store.awards.map((sponsorship, i) => {
              var sponsorSrc = 'https://ddw2.diamondsdirect.com/img/store/awards/' + this.props.route.store_id + '/' + sponsorship.image;
              return <div className={this.state.store.awards.length === 1 ? 'awardLogo single' : 'awardLogo'} key={i}><img src={sponsorSrc} alt={sponsorship.name} /></div>;
            })}
          </div>
        </div> :
        null
      }
      <AntiModal 
        open={this.state.openModal} 
        closeMethod={::this.closeTeamModal}
        resize={this.props.common.modalResize}
        theme={'teamBio'}>
        <TeamModalContainer 
          member={this.state.selectedMember} 
          location={this.state.store}
          store_id={this.props.route.store_id}
          closeMethod={::this.closeTeamModal} 
          modalOpen={this.state.openModal} />
      </AntiModal>
      <AntiModal 
        open={this.state.openHoursModal} 
        closeMethod={::this.closeHoursModal}
        resize={this.props.common.modalResize}>
        <div className='hoursModalWrapper'>
          <div className='hmImage'>
            <img src={`https://ddw2.diamondsdirect.com/img/store/hours_dec.jpg`} alt='Holiday Hours' />
          </div>
          <div className='hmAction'>
            <button type='button' className='actionButton' onClick={::this.closeHoursModal}>Close</button>
          </div>
        </div>
      </AntiModal>
    </div>;
  }
}
export default Store;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const StoreContainer = connect(
  mapStateToProps,
  allActionCreators
)(Store);


// WEBPACK FOOTER //
// ./src/components/views/store/Store.jsx